import { useContext, createContext } from 'react';
import {SettingsContextProps} from "@/app/constants/settings";

// ----------------------------------------------------------------------

export const SettingsContext = createContext(
    {themeMode: 'light', themeColorPresets: "default" } as SettingsContextProps
);

export const useSettingsContext = () => {
    const context = useContext(SettingsContext);

    if (!context) throw new Error('useSettingsContext must be use inside SettingsProvider');

    return context;
};